import { css } from 'emotion';
import theme from '../../../../styles/themes/hopeTheme';

export const container = css`
  text-align: center;
  margin: 0 auto;
  font-family: ${theme.headerBold};
  font-weight: 300;
`;
export const title = css`
  color: #1a1a1a;
  font-size: 33px;
  font-weight: 300;
  line-height: 48px;
  text-align: left;
  margin: 0 auto;
  padding: 40px 24px 0 24px;
  @media screen and (min-width: 600px) {
    font-size: 48px;
    font-weight: 300;
    line-height: 60px;
  }
  @media screen and (min-width: 1200px) {
    padding-top: 0;
    white-space: nowrap;
  }
`;

export const heroSummary = css`
  color: ${theme.hopeBlack};
  white-space: normal;
  font-size: 16px;
  font-weight: 300;
  line-height: 23px;
  padding-top: 40px;
  padding-bottom: 40px;
  @media screen and (min-width: 600px) {
    color: #1a1a1a;
    font-size: 20px;
    font-weight: 300;
    line-height: 30px;
  }
`;

export const membershipFee = css`
  color: #1a1a1a;
  font-size: 20px;
  /* font-weight: bold; */
  line-height: 29px;
  padding-bottom: 20px;
`;

export const membershipFee2 = css`
  color: #1a1a1a;
  font-size: 20px;
  font-weight: bold;
  line-height: 29px;
  padding-bottom: 30px;
`;

export const flexContainer = css`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-wrap: break-word;
  @media screen and (min-width: 1200px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
  }
`;

export const flexItem = css`
  @media screen and (min-width: 1200px) {
    flex: 1;
    position: relative;
    width: 50%;
  }
`;

export const flexWrapContainer = css`
  display: flex;
  align-items: left;
  flex-wrap: wrap;
  height: 100%;
  padding: 0 24px;
`;

export const headerLogoText = css`
  img {
    width: 220px;
  }
  padding-bottom: 24px;
  position: relative;
`;

export const flexWrapCenterContainer = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  height: 100%;
  padding: 0 24px;
`;

export const buttonContainer = css`
  margin-right: 20px;
  margin-bottom: 24px;
`;

export const newLogoAbsolute = css`
  position: absolute;
  top: -30px;
  right: -15px;
  img {
    height: 50px;
    width: 50px;
  }
  @media screen and (min-width: 600px) {
    top: 0;
    right: 60px;
  }
  @media screen and (min-width: 1200px) {
    top: -55px;
    right: -30px;
    margin-bottom: 0;
    margin-top: 0;
    img {
      height: 100px;
      width: 100px;
    }
  }
`;
export const newLogo = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  margin-bottom: -48px;
  margin-top: 24px;
  margin-right: 24px;
  height: 100%;
  img {
    height: 50px;
    width: 50px;
  }
  @media screen and (min-width: 1200px) {
    margin-bottom: 0;
    margin-top: 0;
    img {
      height: 100px;
      width: 100px;
    }
  }
`;

export const rightItemContainer = css`
  position: relative;
  @media screen and (min-width: 1200px) {
    padding: 0 40px;
  }
  @media screen and (min-width: 1400px) {
    padding: 0 90px;
  }
`;
